import React from 'react';
import calendarService from '../../../services/calendarService';
import { useTranslation } from 'react-i18next';
import './CalendarButton.css';

const CalendarButton = ({ event, className = '' }) => {
    const { t } = useTranslation();

    const handleClick = (e) => {
        e.preventDefault();
        calendarService.downloadICal(event);
    };

    return (
        <div className={`calendar-button-wrapper ${className}`}>
            <button
                className="premium-calendar-btn"
                onClick={handleClick}
                title={t('add_to_calendar')}
            >
                <span className="cal-icon">📅</span>
                <span className="cal-text">{t('add_to_calendar')}</span>
            </button>
        </div>
    );
};

export default CalendarButton;
